var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.188.604c1.042-1.047 2.604-.523 3.125 0l2.083 2.094c.521.523 1.042 2.093 0 3.14L8.46 16.828c-2.084 2.094-5.209 1.048-6.772-.522-1.562-1.57-2.604-4.711-.52-6.804l6.77-6.804L8.98 3.744l-6.25 6.281c-2.083 2.094-.83 4.4 0 5.234s3.125 2.093 5.209 0l9.896-9.944c1.041-1.047 0-2.094 0-2.094l-1.042-1.047c-1.042-1.046-2.084 0-2.084 0l-8.854 8.898s-1.042 1.047-.52 1.57c.52.523 1.562-.523 1.562-.523l8.334-8.375 1.041 1.047-8.855 8.898s-1.562 1.57-3.124 0 0-3.14 0-3.14L14.188.603z"
  })));
});
const SvgAttachmentIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttachmentIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDIwIDE4Ij4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjE4OC42MDRjMS4wNDItMS4wNDcgMi42MDQtLjUyMyAzLjEyNSAwbDIuMDgzIDIuMDk0Yy41MjEuNTIzIDEuMDQyIDIuMDkzIDAgMy4xNEw4LjQ2IDE2LjgyOGMtMi4wODQgMi4wOTQtNS4yMDkgMS4wNDgtNi43NzItLjUyMi0xLjU2Mi0xLjU3LTIuNjA0LTQuNzExLS41Mi02LjgwNGw2Ljc3LTYuODA0TDguOTggMy43NDRsLTYuMjUgNi4yODFjLTIuMDgzIDIuMDk0LS44MyA0LjQgMCA1LjIzNC44My44MzMgMy4xMjUgMi4wOTMgNS4yMDkgMGw5Ljg5Ni05Ljk0NGMxLjA0MS0xLjA0NyAwLTIuMDk0IDAtMi4wOTRsLTEuMDQyLTEuMDQ3Yy0xLjA0Mi0xLjA0Ni0yLjA4NCAwLTIuMDg0IDBsLTguODU0IDguODk4cy0xLjA0MiAxLjA0Ny0uNTIgMS41N2MuNTIuNTIzIDEuNTYyLS41MjMgMS41NjItLjUyM2w4LjMzNC04LjM3NSAxLjA0MSAxLjA0Ny04Ljg1NSA4Ljg5OHMtMS41NjIgMS41Ny0zLjEyNCAwYy0xLjU2My0xLjU3IDAtMy4xNCAwLTMuMTRMMTQuMTg4LjYwM3oiLz4KPC9zdmc+Cg==";